<div class="relativePageContainer">
  <div class="page-container">
    <div [ngClass]="isDrawerOpen? '' : 'noShadowOverlay'" class="dx-card">
      <dx-drawer
        (onInitialized)="subscribeToWindowResize()"
        [(opened)]="isDrawerOpen"
        [className]="'drawerParent'"
        [closeOnOutsideClick]="false"
        [height]="'100%'"
        [openedStateMode]="'overlap'"
        [position]="'right'"
        [revealMode]="'slide'"
        template="template">
        <div *dxTemplate="let data of 'template'" [style.width.px]="setWidthOfDrawerPx()" class="drawerInnerContent"
             style="border-radius: 10px;">
          <div *ngIf="!!selectedPartition" [style.width.px]="setWidthOfDrawerPx()" class="drawerContainer">
            <div class="drawerTitleWrapper">
              <h2>{{ selectedPartition.name }}</h2>
              <div style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                <dx-button (onClick)="showEditParentForm()" *ngIf="!isEditMode" [type]="'default'"
                           icon="user" id="editParentPartitionButton"
                           text="{{'REGISTRY.PARTITION.CHANGE_PARENT_PARTITION' | translate}}"></dx-button>
                <dx-button (onClick)="enableEditMode()" *ngIf="!isEditMode" [type]="'default'" icon="edit"
                           id="editPartitionButton"
                           text="{{'BUTTONS.UPDATE' | translate}}"></dx-button>
                <dx-button (onClick)="deletingPartition = true" *ngIf="!isEditMode" icon="trash"
                           text="{{'BUTTONS.DELETE' | translate}}"
                           type="danger"></dx-button>
                <div *ngIf="isEditMode" style="display: flex; flex-direction: row; align-items: center; gap: 10px">
                  <dx-button (onClick)="savePartition();"
                             [disabled]="!isEditFormValid || !partitionEdited" [stylingMode]="'contained'"
                             [type]="'default'"
                             icon="save" text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
                  <dx-button (onClick)="disableEditMode();" [type]="'normal'" [stylingMode]="'contained'"
                             icon="revert" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
                </div>
                <dx-button (onClick)="closeDrawer()" *ngIf="!isEditMode" [type]="'default'"
                           [width]="30"
                           icon="close"></dx-button>
              </div>
            </div>

            <div>
              <dx-form #editPartitionForm
                       (onFieldDataChanged)="checkEditPartitionValidation()"
                       (onOptionChanged)="checkEditPartitionValidation()"
                       [formData]="editedPartition"
                       [height]="'100%'"
                       [labelLocation]="'left'"
                       [labelMode]="'floating'"
              >
                <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
                  <span>{{ tab.title }}</span>
                  <div *ngIf="!checkTabValidity(tab, editPartitionForm)" class="invalidBadge">!</div>
                </div>
                <dxi-item itemType="tabbed">
                  <dxo-tab-panel-options [deferRendering]="false"
                                         [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>
                  <dxi-tab [tabTemplate]="'titleWithValidation'"
                           title="{{'REGISTRY.PARTITION.TABS.INFORMATION' | translate}}">
                    <dxi-item [editorOptions]="partitionEditTextOptions" dataField="name">
                      <dxo-label text="{{'REGISTRY.PARTITION.NAME' | translate}}"></dxo-label>
                      <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                                           [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                                           type="stringLength"></dxi-validation-rule>
                      <dxi-validation-rule message="{{'REGISTRY.PARTITION.VALIDATION.NAME' | translate}}"
                                           type="required"></dxi-validation-rule>
                    </dxi-item>

                    <dxi-item [editorOptions]="partitionEditSwitchOptions" cssClass="noPadding" dataField="active"
                              editorType="dxSwitch">
                      <dxo-label [text]="'REGISTRY.PARTITION.ACTIVE' | translate"></dxo-label>
                    </dxi-item>

                    <dxi-item [editorOptions]="partitionEditTextAreaOptions" dataField="notes" editorType="dxTextArea">
                      <dxi-validation-rule [max]="gmService.STR_DIM_MAX"
                                           [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MAX)"
                                           type="stringLength"></dxi-validation-rule>
                      <dxo-label text="{{'REGISTRY.PARTITION.NOTES' | translate}}"></dxo-label>
                    </dxi-item>
                  </dxi-tab>

                  <dxi-tab [tabTemplate]="'titleWithValidation'"
                           title="{{'REGISTRY.PARTITION.TABS.ADDRESS' | translate}}">
                    <dxi-item [editorOptions]="partitionEditTextOptions" dataField="additionalInfo.address.street">
                      <dxo-label text="{{'REGISTRY.PARTITION.STREET' | translate}}"></dxo-label>
                    </dxi-item>

                    <dxi-item [editorOptions]="partitionEditTextOptions" dataField="additionalInfo.address.number">
                      <dxo-label text="{{'REGISTRY.PARTITION.NUMBER' | translate}}"></dxo-label>
                    </dxi-item>

                    <dxi-item [editorOptions]="partitionEditTextOptions" dataField="additionalInfo.address.city">
                      <dxo-label text="{{'REGISTRY.PARTITION.CITY' | translate}}"></dxo-label>
                    </dxi-item>

                    <dxi-item [editorOptions]="partitionEditTextOptions" dataField="additionalInfo.address.province">
                      <dxo-label text="{{'REGISTRY.PARTITION.PROVINCE' | translate}}"></dxo-label>
                    </dxi-item>

                    <dxi-item [editorOptions]="partitionEditTextOptions" dataField="additionalInfo.address.cap">
                      <dxo-label text="{{'REGISTRY.PARTITION.CAP' | translate}}"></dxo-label>
                    </dxi-item>

                    <dxi-item [editorOptions]="partitionEditTextOptions" dataField="additionalInfo.address.telephone">
                      <dxo-label text="{{'REGISTRY.PARTITION.TELEPHONE' | translate}}"></dxo-label>
                    </dxi-item>
                  </dxi-tab>
                </dxi-item>

              </dx-form>
            </div>


          </div>

        </div>

        <div class="drawerOuterContent">

          <dx-tree-list
            (onRowClick)="onPartitionRowClick($event)"
            [(selectedRowKeys)]="selectedRowPartition"
            [columnAutoWidth]="true"
            [dataSource]="partitions"
            [parentIdExpr]="'parentId'"
            [rootValue]="gmService.user.partition.parentId"
            [showBorders]="true"
            [showRowLines]="false"
            [wordWrapEnabled]="true"
            height="100%"
            id="partitionTree"
            keyExpr="id"
            parentIdExpr="parentId"
          >

            <dxo-toolbar>
              <dxi-item location="before">
                <p style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.PARTITIONS' | translate }}</p>
              </dxi-item>
              <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
              </dxi-item>
              <dxi-item location="before">
                <div *dxTemplate="let data of 'content'">
                  <dx-button (onClick)="showNewPartitionForm()" hint="{{'BUTTONS.HINTS.ADD' | translate}}" icon="add"
                             stylingMode="text">
                    <i class="vr-ic_fluent_add_24_regular"></i>
                  </dx-button>
                </div>
              </dxi-item>
            </dxo-toolbar>

            <dxo-scrolling
              mode="standard">
            </dxo-scrolling>

            <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
            </dxo-search-panel>
            <dxo-selection mode="single"></dxo-selection>
            <dxi-column caption="{{'REGISTRY.PARTITION.NAME' | translate}}" cellTemplate="pictureTemplate"
                        dataField="name"></dxi-column>
            <dxi-column
              [width]="100"
              caption="{{'REGISTRY.PARTITION.ACTIVE' | translate}}"
              dataField="active"
              [showEditorAlways]="false"
              [trueText]="translate.instant('COMMON.YES')"
              [falseText]="translate.instant('COMMON.NO')"></dxi-column>

            <div *dxTemplate="let data of 'pictureTemplate'" style="display: flex; align-items: center; gap: 10px;">
              <label style="font-size: 14px">{{ data.data.name }}</label>
            </div>

          </dx-tree-list>

        </div>

      </dx-drawer>
    </div>
  </div>

</div>

<dx-popup
  (onHiding)="addPartition = false"
  *ngIf="addPartition"
  [dragEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [focusStateEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.PARTITION.TEXT.ADD_PARTITION' | translate"
  [visible]="true"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="createNewPartition()" [height]="40"
               [stylingMode]="'contained'" [type]="'default'" icon="save"
               text="{{'BUTTONS.SAVE' | translate}}"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="addPartition = false; selectedRowNewPartitionForm = undefined;" [height]="40"
               [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <dx-form #newPartitionForm
           [formData]="newPartition"
           [labelLocation]="'top'"
           [labelMode]="'floating'"
  >
    <div *dxTemplate="let tab of 'titleWithValidation'" class="flexRow">
      <span>{{ tab.title }}</span>
      <div *ngIf="!checkTabValidity(tab, newPartitionForm)" class="invalidBadge">!</div>
    </div>
    <dxi-item itemType="tabbed">
      <dxo-tab-panel-options [deferRendering]="false"
                             [elementAttr]="{class: 'tabPanelAbsolute'}"></dxo-tab-panel-options>
      <dxi-tab [tabTemplate]="'titleWithValidation'" title="{{'REGISTRY.PARTITION.PARENT_PARTITION' | translate}}">
        <dxi-item style="gap: 10px; display: flex; flex-direction: column;">
          <div *dxTemplate>
            <div
              style="display: flex; position: absolute; flex-direction: column; top: 0; bottom: 50px; left: 0; right: 0;gap: 10px;padding: 20px;">
              <div style="overflow: hidden;flex: 1 1 100%">
                <dx-tree-list
                  (onRowClick)="onSelectNewParentClick($event)"
                  [(selectedRowKeys)]="selectedRowNewPartitionForm"
                  [columnAutoWidth]="true"
                  [dataSource]="partitions"
                  [parentIdExpr]="'parentId'"
                  [rootValue]="gmService.user.partition.parentId"
                  [showBorders]="true"
                  [showRowLines]="false"
                  [wordWrapEnabled]="true"
                  height="100%"
                  id="selectPartitionTree"
                  keyExpr="id"
                  parentIdExpr="parentId"
                >

                  <dxo-toolbar>
                    <dxi-item location="before">
                      <p
                        style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.PARTITIONS' | translate }}</p>
                    </dxi-item>
                    <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
                    </dxi-item>
                  </dxo-toolbar>

                  <dxo-scrolling
                    mode="standard">
                  </dxo-scrolling>

                  <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
                  </dxo-search-panel>
                  <dxo-selection mode="single"></dxo-selection>
                  <dxi-column caption="{{'REGISTRY.PARTITION.NAME' | translate}}" dataField="name"></dxi-column>

                </dx-tree-list>
              </div>
            </div>
          </div>
        </dxi-item>
      </dxi-tab>

      <dxi-tab [tabTemplate]="'titleWithValidation'" title="{{'REGISTRY.PARTITION.TABS.INFORMATION' | translate}}">
        <dxi-item [editorOptions]="partitionNewTextOptions" dataField="name">
          <dxo-label text="{{'REGISTRY.PARTITION.NAME' | translate}}"></dxo-label>
          <dxi-validation-rule [max]="gmService.STR_DIM_MIN"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MIN)"
                               type="stringLength"></dxi-validation-rule>
          <dxi-validation-rule message="{{'REGISTRY.PARTITION.VALIDATION.NAME' | translate}}"
                               type="required"></dxi-validation-rule>
        </dxi-item>

        <dxi-item [editorOptions]="partitionNewTextOptions" dataField="active" editorType="dxSwitch">
          <dxo-label [text]="'REGISTRY.PARTITION.ACTIVE' | translate"></dxo-label>
        </dxi-item>

        <dxi-item [editorOptions]="partitionNewTextAreaOptions" dataField="notes" editorType="dxTextArea">
          <dxi-validation-rule [max]="gmService.STR_DIM_MAX"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MAX)"
                               type="stringLength"></dxi-validation-rule>
          <dxo-label text="{{'REGISTRY.PARTITION.NOTES' | translate}}"></dxo-label>
        </dxi-item>

      </dxi-tab>

      <dxi-tab [tabTemplate]="'titleWithValidation'" title="{{'REGISTRY.PARTITION.TABS.ADDRESS' | translate}}">
        <dxi-item dataField="additionalInfo.address.street">
          <dxo-label text="{{'REGISTRY.PARTITION.STREET' | translate}}"></dxo-label>
        </dxi-item>

        <dxi-item dataField="additionalInfo.address.number">
          <dxo-label text="{{'REGISTRY.PARTITION.NUMBER' | translate}}"></dxo-label>
        </dxi-item>

        <dxi-item dataField="additionalInfo.address.city">
          <dxo-label text="{{'REGISTRY.PARTITION.CITY' | translate}}"></dxo-label>
        </dxi-item>

        <dxi-item dataField="additionalInfo.address.province">
          <dxo-label text="{{'REGISTRY.PARTITION.PROVINCE' | translate}}"></dxo-label>
        </dxi-item>

        <dxi-item dataField="additionalInfo.address.cap">
          <dxo-label text="{{'REGISTRY.PARTITION.CAP' | translate}}"></dxo-label>
        </dxi-item>

        <dxi-item dataField="additionalInfo.address.telephone">
          <dxo-label text="{{'REGISTRY.PARTITION.TELEPHONE' | translate}}"></dxo-label>
        </dxi-item>
      </dxi-tab>
    </dxi-item>

  </dx-form>

</dx-popup>

<dx-popup
  [(visible)]="deletingPartition"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [fullScreen]="appService.isSmallScreen()"
  [height]="200"
  [hideOnOutsideClick]="false"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.PARTITION.TEXT.DELETE_PARTITION' | translate"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="deletePartition()" [height]="40" icon="trash" text="{{'BUTTONS.DELETE' | translate}}"
               type="danger"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="deletingPartition = false" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; align-items: center;">
    <label
      [innerHTML]="'REGISTRY.PARTITION.TEXT.CONFIRM_DELETE' | translate  : { partitionName: selectedPartition?.name } "
      style="font-size: 18px"></label>
  </div>
</dx-popup>

<dx-popup
  (onHiding)="editParent = false"
  *ngIf="editParent"
  [fullScreen]="appService.isSmallScreen()"
  [dragEnabled]="false"
  [focusStateEnabled]="false"
  [hideOnOutsideClick]="true"
  [showCloseButton]="false"
  [showTitle]="true"
  [title]="'REGISTRY.PARTITION.TEXT.CHANGE_PARENT_PARTITION' | translate"
  [visible]="true"
  [width]="660"
>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="updateParentPartition()" [disabled]="!checkIfParentChanged()" [height]="40" icon="save"
               text="{{'BUTTONS.SAVE' | translate}}" type="default"></dx-button>
  </dxi-toolbar-item>
  <dxi-toolbar-item
    location="after"
    toolbar="bottom"
  >
    <dx-button (onClick)="closeEditParentForm()" [height]="40" [stylingMode]="'outlined'"
               icon="close" text="{{'BUTTONS.CANCEL' | translate}}"></dx-button>
  </dxi-toolbar-item>

  <div style="height: 100%; display: flex; flex-direction: column; align-items: flex-start;">
    <dx-tree-list
      (onRowClick)="onSelectEditParentClick($event)"
      [(selectedRowKeys)]="selectedRowEditParentPartitionForm"
      [autoExpandAll]="true"
      [columnAutoWidth]="true"
      [dataSource]="selectableParentPartitions"
      [rootValue]="gmService.user.partition.parentId"
      [showBorders]="true"
      [showRowLines]="false"
      [wordWrapEnabled]="true"
      height="100%"
      id="selectParentPartitionTree"
      keyExpr="id"
      parentIdExpr="parentId"
    >

      <dxo-toolbar>
        <dxi-item location="before">
          <p style="font-size: 22px; margin: 0 0 0 10px;">{{ 'MENU_VOICE.REGISTRY.PARTITIONS' | translate }}</p>
        </dxi-item>
        <dxi-item cssClass="fullWidthSearchBar" location="before" name="searchPanel">
        </dxi-item>
      </dxo-toolbar>

      <dxo-scrolling
        mode="standard">
      </dxo-scrolling>
      <dxo-search-panel [visible]="true" placeholder="{{'PLACEHOLDERS.SEARCH' | translate}}">
      </dxo-search-panel>
      <dxo-selection mode="single"></dxo-selection>
      <dxi-column caption="{{'REGISTRY.PARTITION.NAME' | translate}}" dataField="name"></dxi-column>

    </dx-tree-list>
  </div>
</dx-popup>
